const themes = {
  colors: {
    primary: '#2C3654',
    secondary: '#F2B10C',
    warning: '#F2B10C',
    danger: '#E74B4B',
    success: '#2BC37F',
    defaultBlue: '#4D8AF0',
    white: '#ffffff',
    black: '#000000',
    darkPrimary: '#111111',
    darkSecondary: '#222222',
    darkTertiary: '#333333',
    darkQuaternary: '#444444',
    grayPrimary: '#666666',
    graySecondary: '#999999',
    lightPrimary: '#eeeeee',
    lightSecondary: '#dddddd',
    lightTertiary: '#cccccc',
    lightQuaternary: '#f4f6f9',
    lightBlue: '#8EA6B3',
    lightGreen: '#128C7E',
  },
  fonts: {
    bold: require('_/assets/w3lcome/fonts/BaiJamjuree-Bold.ttf'),
    light: require('_/assets/w3lcome/fonts/BaiJamjuree-Light.ttf'),
    medium: require('_/assets/w3lcome/fonts/BaiJamjuree-Medium.ttf'),
    regular: require('_/assets/w3lcome/fonts/BaiJamjuree-Regular.ttf'),
    semibold: require('_/assets/w3lcome/fonts/BaiJamjuree-SemiBold.ttf'),
  },
  images: {
    logo: require('_/assets/w3lcome/logo.png'),
    noCompany: require('_/assets/w3lcome/no-company.png'),
    emailVerification: require('_/assets/w3lcome/emailVerification.png'),
    forgotPassword: require('_/assets/w3lcome/forgot-password.png'),
    empty: require('_/assets/w3lcome/empty.png'),
    bigCalendar: require('_/assets/w3lcome/big-calendar.png'),
    intro1: require('_/assets/w3lcome/intro1.png'),
    intro2: require('_/assets/w3lcome/intro2.png'),
    intro3: require('_/assets/w3lcome/intro3.png'),
    emailSent: require('_/assets/w3lcome/email-sent.png'),
    loginImage: require('_/assets/w3lcome/login-img.png'),
    packageImg: require('_/assets/w3lcome/package.png'),
    spinner: require('_/assets/w3lcome/spinner.png'),
    avatarSquare: require('_/assets/w3lcome/avatar-square.png'),
    checkCircle: require('_/assets/w3lcome/check-circle.png'),
    noMeeting: require('_/assets/w3lcome/no-meeting.png'),
    qrcodeIcon: require('_/assets/qrcode-icon.png'),
    calendarIcon: require('_/assets/calendar-icon.png'),
    calendar: require('_/assets/calendar.png'),
    googleIcon: require('_/assets/google-icon.png'),
    switchCamera: require('_/assets/switchCamera.png'),
    qrCodeBorder: require('_/assets/qrCodeBorder.png'),
    splash: require('_/assets/w3lcome/splash.png'),
    emptyInvites: require('_/assets/w3lcome/emptyInvites.png'),
    receivedInvite: require('_/assets/w3lcome/receivedInvite.png'),
    notFoundInvite: require('_/assets/w3lcome/notFoundInvite.png'),
    meetingError: require('_/assets/w3lcome/meetingError.png'),
    qrcodeFrame: require('_/assets/w3lcome/qrcodeFrame.png'),
    qrcodeExpired: require('_/assets/w3lcome/qrcodeExpired.png'),
    spaceManagementIcon: require('_/assets/spaceManagement.png'),
  },
};

export default themes;
